import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getMachineBrigades(companyId, machineId) {
	return dataTransferWrap(
		ModulesMap.MACHINE_BRIGADE,dtConfig[ModulesMap.MACHINE_BRIGADE].getMachineBrigades,
		{
			urlParams: {
				companyId: companyId,
				machineId,
			},
		},
	)
}

function createMachineBrigade(companyId, machineId, data) {
	return dataTransferWrap(
		ModulesMap.MACHINE_BRIGADE,dtConfig[ModulesMap.MACHINE_BRIGADE].createMachineBrigade,
		{
			urlParams: {
				companyId,
				machineId,
			},
			...data,
		},
	)
}

function getMachineBrigade(companyId, machineId, brigadeId) {
	return dataTransferWrap(
		
		ModulesMap.MACHINE_BRIGADE,dtConfig[ModulesMap.MACHINE_BRIGADE].getMachineBrigade,
		{
			urlParams: {
				companyId,
				machineId,
				brigadeId,
			},
		},
	)
}

function patchMachineBrigade(companyId, machineId, brigadeId, data) {
	return dataTransferWrap(
		ModulesMap.MACHINE_BRIGADE,dtConfig[ModulesMap.MACHINE_BRIGADE].patchMachineBrigade,
		{
			urlParams: {
				companyId,
				machineId,
				brigadeId,
			},
			...data,
		},
	)
}

function putMachineBrigade(companyId, machineId, brigadeId, data) {
	return dataTransferWrap(
		ModulesMap.MACHINE_BRIGADE,dtConfig[ModulesMap.MACHINE_BRIGADE].putMachineBrigade,
		{
			urlParams: {
				companyId,
				machineId,
				brigadeId,
			},
			...data,
		},
	)
}

function deleteMachineBrigade(companyId, machineId, brigadeId) {
	return dataTransferWrap(
		ModulesMap.MACHINE_BRIGADE,dtConfig[ModulesMap.MACHINE_BRIGADE].deleteMachineBrigade,
		{
			urlParams: {
				companyId,
				machineId,
				brigadeId,
			},
		},
	)
}

export default {
	getMachineBrigades,
	getMachineBrigade,
	patchMachineBrigade,
	putMachineBrigade,
	createMachineBrigade,
	deleteMachineBrigade,
}